<template>
  <div class="register-box">
    <div v-if="isCabinet()" class="register-logo">
      <b>Cabinet</b> Business
    </div>
    <div v-else class="register-logo">
      <b>Cabinet</b> Backoffice
    </div>

    <div class="register-box-body">
      <p class="login-box-msg">Signin</p>

      <div class="form-group has-feedback">
        <input v-model="email" type="email" class="form-control" placeholder="Email">
        <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
      </div>
      <div class="form-group has-feedback">
        <input v-model="password" type="password" class="form-control" placeholder="Password">
        <span class="glyphicon glyphicon-lock form-control-feedback"></span>
      </div>
      <div class="row">
        <div class="col-xs-8">

        </div>
        <div class="col-xs-4">
          <button type="submit" v-on:click="signin" class="btn btn-primary btn-block btn-flat">Signin</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import cookies from 'vue-cookies';
  import jwt from 'jsonwebtoken';

  export default {
    name: 'Signin',
    data: function () {
      return {
        email: null,
        password: null,
        errorMessage: null,
        auth: JSON.parse(localStorage.getItem('user'))
      };
    },
    created () {
      localStorage.removeItem('user');
    },
    methods: {
      isCabinet: function () {
        return window.application === 'cabinet';
      },
      signin: function () {
        let self = this;

        axios.post(

          window.host + '/authorization',
          {
            email: self.email,
            password: self.password
          })
          .then(function (response) {
            console.log(response.data);

            localStorage.setItem('user', JSON.stringify(response.data.model));
            let token = jwt.sign(
              {
                accountId: response.data.accountId,
                token: response.data.token
              },
              'secret',
              {expiresIn: 86400});

            cookies.set('jwt', token)

            window.location.replace('/');
          })
          .catch(function (error) {
            if (error.response.status === 401) {
              self.errorMessage = 'Неверный логин или пароль';
            }
          });
      }
    }
  };
</script>

<style scoped>
  body {
    background: #d2d6de;
  }

  h1, h2 {
    font-weight: normal;
    color: #444;
  }

  .signin__input-group {
    margin-bottom: 12px;
  }

  .signin__button-wrapper {
    margin: 0 auto;
    width: 160px;
  }
</style>
